import GlobalStoreService from "./global-store.service";
import TrackingMiddlewareService from './tracking-middleware.service'
import InitializeChatBotService from './initialize-chatbot-data.service'
import LoginService from './handle-user-login.service'
import TrackingKey from '../enums/trackingKey'


const checkAndResolveBasicToken = () => {
    return new Promise((resolve, reject) => {
        if (!GlobalStoreService.get("basicToken")) {
            InitializeChatBotService.getBasicTokenAndInitializeChatBotData().then(
                () => {
                    resolve();
                }
            ).catch(
                () => {
                    reject();
                })
        }
        else {
            resolve();
        }
    })
}

const checkAndResolveDefaultScenarios = () => {
    return new Promise((resolve, reject) => {
        let scenarioList = GlobalStoreService.get('scenarioList');
        if (!scenarioList || (scenarioList && (!scenarioList[GlobalStoreService.get('currentBotType')] || (scenarioList[GlobalStoreService.get('currentBotType')] && scenarioList[GlobalStoreService.get('currentBotType')].length === 0)))) {
            InitializeChatBotService.getDefaultScenariosPromise(GlobalStoreService.get('currentBotType')).then(
                () => {
                    resolve();
                },
                () => {
                    // TrackingMiddlewareService.trackErrorBackend("");
                    TrackingMiddlewareService.trackEvent(TrackingKey.ERROR_BACKEND)
                    reject();
                }
            )
        }
        else {
            resolve();
        }
    })
}

const checkAndResolveLoggedInToken = () => {
    return new Promise((resolve, reject) => {
        if (GlobalStoreService.get("APP_CONTEXT")) {
            if (!GlobalStoreService.get('loggedInToken')) {
                LoginService.loginInApp().then(
                    () => {
                        resolve();
                    }).catch(
                        () => {
                            reject();
                        })
            }
            else {
                resolve();
            }
        }
        else {
            resolve();
        }
    })
}

const handleInitializationErrors = (errors) => {
    return new Promise((resolveErrors, rejectErrors) => {
        checkAndResolveBasicToken().then(
            () => {
                checkAndResolveDefaultScenarios().then(
                    () => {
                        checkAndResolveLoggedInToken().then(
                            () => {
                                if (GlobalStoreService.get("APP_CONTEXT")) {
                                    switch (GlobalStoreService.get('userProfileType')) {
                                        case 'SINGLE': {
                                            resolveErrors();
                                            break;
                                        }
                                        case 'MULTIPLE': {
                                            if (GlobalStoreService.get('primaryNumber')) {
                                                GlobalStoreService.set('currentNumber', GlobalStoreService.get('primaryNumber'))
                                            }
                                            resolveErrors('INITIATE_AFTER_LOGIN_IN_MULTIPLE');
                                        }
                                    }
                                }
                                else {
                                    resolveErrors();
                                }
                            }
                        ).catch(
                            () => {
                                rejectErrors();
                            }
                        )
                    }).catch(
                        () => {
                            rejectErrors();
                        }
                    )
            }
        ).catch(
            () => {
                rejectErrors();
            }
        )
    })

}

export { handleInitializationErrors }


// WEBPACK FOOTER //
// ./src/services/handle-initialization-errors.service.js